<h3>Informações da inpugnação</h3>
<hr>

<div class="col-md-12 animated fadeIn">
  <p-editor [(ngModel)]="observacao"></p-editor>
  <hr>
  <button type="button" class="btn btn-sm btn-primary ">Enviar</button>
</div>

<br>
<br>